import axios from 'axios';
import logger from './ClientLogger';
import Auth from './Auth';

export default class StravaAuth {
    private clientId: string;
    private clientSecret: string;
    private urlAuth: string;
    private urlToken: string;
    private clientRedirect: string;

    constructor() {
        this.clientId = process.env.VUE_APP_STRAVA_CLIENT_ID;
        this.clientSecret = process.env.VUE_APP_STRAVA_CLIENT_SECRET;
        this.clientRedirect = process.env.VUE_APP_STRAVA_CLIENT_REDIRECT;
        this.urlAuth = process.env.VUE_APP_STRAVA_API_AUTH;
        this.urlToken = process.env.VUE_APP_STRAVA_API_TOKEN;
    }

    public navigateOAuth() {
        window.location.href = this.getAuthUrl();
    }

    public isTokenExchangePath(path: string) {
        return path === '/token-exchange/app';
    }

    public async tokenRefresh(refreshToken: string): Promise<Auth> {
        const url = `${this.urlToken}?client_id=${this.clientId}&client_secret=${this.clientSecret}` +
            `&refresh_token=${refreshToken}&grant_type=refresh_token`;
        const resp = await axios.post(url);
        logger.log(`tokenRefresh: ${resp.data}`);
        const auth = {
            accessToken: resp.data.access_token,
            refreshToken: resp.data.refresh_token,
            expiresAt: resp.data.expires_at,
        } as Auth;
        return auth;
    }

    public async tokenExchange(code: string, callback: (a: object, b: Auth) => any) {
        const url = `${this.urlToken}?client_id=${this.clientId}&client_secret=${this.clientSecret}` +
            `&code=${code}&grant_type=authorization_code`;
        const resp = await axios.post(url);
        logger.log(resp.data);
        const auth = {
            accessToken: resp.data.access_token,
            refreshToken: resp.data.refresh_token,
            expiresAt: resp.data.expires_at,
        } as Auth;
        callback(resp.data.athlete, auth);
    }

    public async tokenExchangeAsync(code: string) {
        const url = `${this.urlToken}?client_id=${this.clientId}&client_secret=${this.clientSecret}` +
            `&code=${code}&grant_type=authorization_code`;
        const resp = await axios.post(url);
        logger.log(resp.data);
        const auth = {
            accessToken: resp.data.access_token,
            refreshToken: resp.data.refresh_token,
            expiresAt: resp.data.expires_at,
        } as Auth;
        return { auth, athlete: resp.data.athlete };
    }

    private getAuthUrl(): string {
        const writeScopes = ['activity:write', 'profile:write'];
        const readScopes = ['read_all', 'activity:read_all', 'profile:read_all'];
        const url = `${this.urlAuth}?client_id=${this.clientId}&redirect_uri=${this.clientRedirect}` +
            `&response_type=code&scope=${readScopes.concat(writeScopes).join(',')}&approval_prompt=auto`;
        return url;
    }
}
